module.exports = __webpack_public_path__ + "static/media/rackham03full.702d2fa7.jpg";